import React from "react";
import { useNavigate } from "react-router-dom";

const Blogs = () => {
    const navaigate = useNavigate();

    const navigateToHome = () => {
        navaigate('/')
    }



  return (
    <div class="hero min-h-screen bg-accent">
      <div class="hero-content text-center">
        <div class="">
          
        <h1 class="text-5xl font-bold text-primary my-5">Comming Soon !!</h1>
          <button onClick={navigateToHome} class="btn btn-primary">Back To Home</button>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
